import React from 'react';
import {Col, Container, Row, Button} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faLinkedin} from '@fortawesome/free-brands-svg-icons';
import jonHeadshot from '../../assets/images/jon-cooke.jpg'; // adjust path

const FounderSection = () => (
    <section className="py-5">
        <Container>
            <div className="text-center mb-5">
                <div className="section-label">Who Built This</div>
                <h2>Thirty years of doing this work.</h2>
            </div>

            <Row className="g-4 align-items-center justify-content-center">
                <Col xs={12} md={4} lg={3} className="text-center">
                    <img
                        src={jonHeadshot}
                        alt="Jon Cooke, Founder &amp; CEO of Nebulyx AI"
                        className="rounded-circle shadow"
                        style={{width: 200, height: 200, objectFit: 'cover'}}
                    />
                </Col>
                <Col xs={12} md={8} lg={6}>
                    <h3 style={{textAlign: 'left'}}>Jon Cooke</h3>
                    <p className="lead text-primary mb-3" style={{fontSize: '1.05rem'}}>
                        Founder &amp; CEO, Nebulyx AI
                    </p>
                    <p style={{color: '#374151', lineHeight: 1.75}}>
                        30+ years building production AI, NLP, and graph-based systems for regulated
                        industries. Patent-pending architect of Nebulyx Cognition.
                    </p>
                    <ul style={{listStyle: 'none', paddingLeft: 0, color: 'var(--gray)'}}>
                        <li className="mb-2">→ <strong style={{color: 'var(--accent)'}}>ex-Databricks</strong> - EMEA Head of Solutions Architecture</li>
                        <li className="mb-2">→ <strong style={{color: 'var(--accent)'}}>ex-PwC</strong> - Financial Services Director</li>
                        <li className="mb-2">→ Built mission-critical decisioning systems across finance, healthcare, and government</li>
                    </ul>
                    <Button
                        variant="outline-primary"
                        href="https://www.linkedin.com/in/jon-cooke-096bb0/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="mt-2">
                        <FontAwesomeIcon icon={faLinkedin}/> Connect on LinkedIn
                    </Button>
                </Col>
            </Row>
        </Container>
    </section>
);

export default FounderSection;